import type { FlagField, Grant } from './grant';

/**
 * The permissions each manage page is drawn for, any one of which opens it: its sidebar link reads
 * them (users decision 19), and the page, opened by URL by someone holding none, draws "Not allowed"
 * instead (ENG-10284). One table, so the link and the page cannot come to disagree.
 *
 * Study settings holds a section for each of its three, and draws each only for its own (ENG-10304):
 * Manage API keys alone opens the page on its API key, Manage study flags alone on its Case Team.
 */
export const PAGE_PERMISSION = {
  forms: ['manageForms'],
  people: ['manageUsers'],
  studySettings: ['manageStudy', 'manageApiKeys', 'manageStudyFlags']
} as const satisfies Record<string, readonly FlagField[]>;

/** Whether `grant` opens a page drawn for `permission`: it holds any one of them. */
export const opensPage = (grant: Grant | undefined, permission: readonly FlagField[]): boolean =>
  permission.some(field => grant?.[field] === true);

/**
 * Whether the caller may see a page: `unread` until the routed study's permissions arrive, which is
 * neither, so a page opened by URL draws nothing rather than "Not allowed" or controls it will take
 * back.
 */
export type PageAccess = 'unread' | 'allowed' | 'refused';
